export default __webpack_public_path__ + "static/media/appstore.81528c00.svg";